import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFileContract } from 'react-icons/fa';
import SEOMetadata from '../SEOMetadata/SEOMetadata';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFEEED] to-white">
        <SEOMetadata 
        title="Terms of Service | PhDScanner"
        description="Read PhDScanner's Terms of Service to understand the rules and guidelines for using our platform."
        keywords="PhDScanner terms, terms of service, user agreement, PhD platform terms"
        imageUrl="https://www.phdscanner.com/phdscanner_logo.webp"
        url="https://www.phdscanner.com/terms"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Back Button */}
        <Link 
          to="/" 
          className="mb-8 inline-flex items-center text-[#DB4F40] hover:text-[#C64537] font-medium transition-colors"
        >
          <FaArrowLeft className="mr-2" />
          Back to Home
        </Link>

        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="bg-[#DB4F40]/10 rounded-full p-4 inline-block mb-6">
            <FaFileContract className="text-4xl text-[#DB4F40]" />
          </div>
          <h1 className="text-4xl font-extrabold text-[#1B222A] mb-4">
            Terms of Service
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Please read these terms carefully before using our services.
          </p>
        </div>

        {/* Content Container */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 border border-[#DB4F40]/20">
          {/* General Terms Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              General Terms
            </h2>
            
            <div className="space-y-6 text-gray-700">
              <p>
                By accessing and using PhDScanner, you accept and agree to be bound by these Terms of Service.
              </p>
              <p>
                You must be at least 16 years of age to use our services or have parental consent if younger.
              </p>
              <p>
                You are responsible for maintaining the confidentiality of your account and password.
              </p>
            </div>
          </section>

          {/* User Responsibilities Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              User Responsibilities
            </h2>
            
            <div className="space-y-4 text-gray-700">
              <p>
                You agree not to use the service for any unlawful purpose or in any way that might harm the service.
              </p>
              <p>
                You must not attempt to gain unauthorized access to any part of the service.
              </p>
              <p>
                Any content you submit must be accurate and not violate any third-party rights.
              </p>
            </div>
          </section>

          {/* Service Modifications Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              Service Modifications
            </h2>
            
            <div className="space-y-4 text-gray-700">
              <p>
                We reserve the right to modify or discontinue the service at any time without notice.
              </p>
              <p>
                We may update these terms from time to time, and your continued use constitutes acceptance of those changes.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section>
            <h3 className="text-2xl font-bold text-[#1B222A] mb-4">
              Questions About Our Terms?
            </h3>
            <p className="text-gray-700 mb-4">
              Contact our admin at:
            </p>
            <a 
              href="mailto:admin@phdscanner.com" 
              className="text-[#DB4F40] hover:text-[#C64537] font-medium transition-colors"
            >
              admin@phdscanner.com
            </a>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;